/* eslint-disable */
"use strict";

import QFLayoutHeader from "./header.js";
import QFCard from "./../../components/card.js";
import { QFUtil } from "./../../components/util.js";
import QFLayoutSubheader from "./subheader.js";

var QFLayoutStickyCard = function() {
    // Private properties
	var _element;
    var _object;

	// Private functions
	var _init = function() {
		var offset = 300;

		if (typeof QFLayoutHeader !== 'undefined') {
			offset = QFLayoutHeader.getHeight();
		}

        _object = new QFCard(_element, {
			sticky: {
				offset: offset,
				zIndex: 90,
				position: {
					top: function() {
						var pos = 0;
                        var body = QFUtil.getBody();

						if (QFUtil.isBreakpointUp('lg')) {
							if (typeof QFLayoutHeader !== 'undefined' && QFLayoutHeader.isFixed()) {
								pos = pos + QFLayoutHeader.getHeight();
							}

							if (typeof QFLayoutSubheader !== 'undefined' && QFLayoutSubheader.isFixed()) {
								pos = pos + QFLayoutSubheader.getHeight();
							}
						} else {
							if (typeof QFLayoutHeader !== 'undefined' && QFLayoutHeader.isFixedForMobile()) {
								pos = pos + QFLayoutHeader.getHeightForMobile();
							}
						}

						pos = pos - 1; // remove header border width

						return pos;
					},
					left: function(card) {
						return QFUtil.offset(_element).left;
					},
					right: function(card) {
						var body = QFUtil.getBody();

						var cardWidth = parseInt(QFUtil.css(_element, 'width'));
						var bodyWidth = parseInt(QFUtil.css(body, 'width'));
						var cardOffsetLeft = QFUtil.offset(_element).left;

						return bodyWidth - cardWidth - cardOffsetLeft;
					}
				}
			}
		});

		_object.initSticky();

		QFUtil.addResizeHandler(function() {
			_object.updateSticky();
		});
	}

    // Public methods
	return {
		init: function(id) {
            _element = QFUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
			_init();
		},

		update: function() {
			if (_object) {
				_object.updateSticky();
			}
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = QFLayoutStickyCard;
}

export default QFLayoutStickyCard;